export enum LOCATION_HREF {
  HASH_BANG = '#!',
}
